// extracted by mini-css-extract-plugin
export default {"card":"card_card__5+HS-","light":"card_light__7OUzp","hoverable":"card_hoverable__y5zG1","card-body":"card_card-body__pz7t5"};